module.exports = require("@dnd-kit/core");